<template>
    <div>
        <p>simple component</p>
    </div>
</template>
<script>
    export default {
        name: "SimpleComponent"
    }
</script>